import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import AdditionalRecipientCreate from "../../AdditionalRecipientCreate";
import CommonAssignLabelPopup from "../../_utils/CommonPopups/CommonAssignLabelPopup";
import CategoriesEdit from "../../_utils/AccountCreationComponents/CategoriesEdit";
import AssignLabels from "../../_utils/AccountCreationComponents/AssignLabels";
import AdditionalRecipients from "../../_utils/AccountCreationComponents/AdditionalRecipients";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import CommonLayout from "../../_utils/CommonLayout";
import TEXT from "../../../utils/globalText";

const FieldForceCategoryAndLabels = (props) => {
  const { id } = useParams();
  const [labelpopup, setLabelpopup] = useState(false);
  const categories = props.categories;
  const [labels, setLabels] = useState([]);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);
  const [showAdditionalRecipient, setShowAdditionalRecipient] = useState([]);
  const [recipientButtonDisabled, setRecipientButtonDisabled] = useState(true);
  const [showAdditionalSection, setShowAdditionalSection] = useState(false);
  const [additionalChip, setAdditionalChip] = useState(showAdditionalRecipient);
  const [tempRecipients, setTempRecipients] = useState([]);
  const [originalRecipients, setOriginalRecipients] = useState([]);

  const isUppercaseLabel = (value) => {
    if (typeof value !== "string") return false;
    const trimmed = value.trim();
    if (!trimmed) return false;
    return /[A-Z]/.test(trimmed);
  };

  const filterUppercaseLabels = (labelList) =>
    (Array.isArray(labelList) ? labelList : []).filter(
      (labelValue) => !isUppercaseLabel(labelValue),
    );

  const openAdditionalRecipients = () => {
    const confirmed = props?.createRecipient || [];
    setTempRecipients(confirmed);
    setOriginalRecipients(confirmed);
    setShowAdditionalSection(true);
  };

  const handleConfirmRecipients = () => {
    if (recipientButtonDisabled) return;

    props?.setCreateRecipient(tempRecipients);
    setShowAdditionalSection(false);
  };

  useEffect(() => {
    const changed =
      JSON.stringify(tempRecipients) !== JSON.stringify(originalRecipients);

    setRecipientButtonDisabled(!changed);
  }, [tempRecipients, originalRecipients]);

  const toggleSelection = (category) => {
    if (props?.type === "switch_account") {
      return;
    }
    const categoryId = category.id;
    props?.setSelectedCatFields((prevSelectedFields) => {
      let updatedSelectedFields;

      if (categoryId === "Select All") {
        const isAllSelected = prevSelectedFields.length === categories.length;
        props?.setSelectAllChecked(!isAllSelected);
        updatedSelectedFields = isAllSelected
          ? []
          : categories.map((cat) => cat.id);
      } else {
        if (prevSelectedFields.includes(categoryId)) {
          updatedSelectedFields = prevSelectedFields.filter(
            (id) => id !== categoryId,
          );
        } else {
          updatedSelectedFields = [...prevSelectedFields, categoryId];
        }
        props?.setSelectAllChecked(
          updatedSelectedFields.length === categories.length,
        );
      }

      return updatedSelectedFields;
    });
  };

  const handleCategorySelect = (selectedCategories) => {
    let selectedCategoryNames = [];

    if (selectedCategories.length > GlobalConfiguration.lengthCheckZero) {
      selectedCategoryNames = selectedCategories
        .map((categoryId) => {
          const category = categories.find(
            (category) => category.id === categoryId,
          );
          return category ? category.name : null;
        })
        .filter((name) => name !== null);
    } else {
      selectedCategoryNames = categories.map((category) => category.name);
    }

    props.onSelectFieldsChange(selectedCategoryNames);
  };

  useEffect(() => {
    const availableLabels = sessionStorage?.getItem("fFAccAvailableLabels");
    if (availableLabels) {
      try {
        const parsedLabels = JSON.parse(availableLabels);
        setLabels(filterUppercaseLabels(parsedLabels || []));
      } catch (err) {
        setLabels([]);
      }
    }
  }, []);

  const handleClose = (finalLabels) => {
    setLabelpopup(false);
    if (finalLabels === undefined || finalLabels === null) return;
    props?.setPayload((prevPayload) => ({
      ...prevPayload,
      labels: finalLabels,
    }));
    props?.setSelectedLabelsCreate(finalLabels);
  };

  useEffect(() => {
    if (props?.type === "switch_account") {
      const payloadCategories =
        props?.payload?.categories?.split(",")?.map((item) => item.trim()) ||
        [];

      const matchedCategoryIds = categories
        .filter((category) => payloadCategories.includes(category.name))
        .map((category) => category.id);

      props?.setSelectedCatFields(matchedCategoryIds);
    }
  }, [props?.type]);

  useEffect(() => {
    handleCategorySelect(props?.selectedCatFields);
  }, [props?.selectedCatFields]); // ensures parent stays updated

  useEffect(() => {
    if (labelpopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [labelpopup]);

  return (
    <>
      {showAdditionalSection && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <AdditionalRecipientCreate
            type="createFlow"
            finalRecipients={props?.createRecipient}
            initialRecipientCount={GlobalConfiguration.lengthCheckZero}
            setShowAdditionalSection={setShowAdditionalSection}
            accountID={id}
            showAdditionalRecipient={showAdditionalRecipient}
            setShowAdditionalRecipient={setShowAdditionalRecipient}
            handleConfirm={handleConfirmRecipients}
            recipients={tempRecipients}
            setRecipients={setTempRecipients}
            buttonDisabled={recipientButtonDisabled}
            setButtonDisabled={setRecipientButtonDisabled}
            additionalChip={additionalChip}
            setAdditionalChip={setAdditionalChip}
          />
        </div>
      )}

      {labelpopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated accounts."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            isLabelPopupOpen={labelpopup}
            selectedLabelsCreate={props?.selectedLabelsCreate}
            setSelectedLabelsCreate={props?.setSelectedLabelsCreate}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            type="create"
          />
        </div>
      )}
      <div className="px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base">
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <CategoriesEdit
              type="CategoryCreate"
              sortedCategories={categories}
              selectedCategories={props?.selectedCatFields}
              handleCategorySelect={toggleSelection}
              Title={"Categories"}
              SubTitle="Not selecting categories will assign all, including future ones, to this account. This is not recommended for security reasons."
              TitleFontcolor="text-primary"
              TextSize="font-md"
              SubTitleFontcolor="text-secondary"
              SubTitleTextSize="font-xs"
              TitleFontWeight="semibold"
              SubTitleFontWeight="normal"
              flow={props?.type}
            />
          </div>
          <div className="w-width-full lg:max-w-[var(--create-box-width)] flex flex-col gap-gap-md">
            <AssignLabels
              setLabelpopup={setLabelpopup}
              labels={props?.payload?.labels}
              subText1={TEXT?.LABELS_ACCOUNT_USAGE_NOTE}
              isOptional={true}
              type={"ffaccount"}
            />
            <AdditionalRecipients
              setShowAdditionalSection={openAdditionalRecipients}
              recipients={props?.createRecipient}
            />
          </div>
        </CommonLayout>
      </div>
    </>
  );
};

export default FieldForceCategoryAndLabels;
